export enum FileSource {
  ApsCashplus = 'APS / Cashplus',
  Cardnet = 'Cardnet',
  Cardone = 'Cardone',
  Gocardless = 'Gocardless',
  DojoDirectSplit = 'Dojo (Direct Split)',
  Modulr = 'Modulr',
  Fdms = 'FDMS',
  Custom = 'Custom',
}

export interface UploadedFile {
  id?: string // optional because it will be generated by Postgres
  name: string
  date: string // ISO 8601 datetime string, e.g. "2025-04-16T14:00:00Z"
  source: FileSource
  created_by: string
  status: string
  download_url: string
  file_hash: string
  repayment_count?: number
  country: string
}

export type UploadedFiles = Array<UploadedFile>
